import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_header_action = _resolveComponent("ontos-header-action")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_ontos_create_instance_dialog = _resolveComponent("ontos-create-instance-dialog")!
  const _component_ontos_link_existing_dialog = _resolveComponent("ontos-link-existing-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.offersCreate || _ctx.offersLink)
      ? (_openBlock(), _createBlock(_component_v_menu, {
          key: 0,
          modelValue: _ctx.menuOpen,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.menuOpen) = $event)),
          target: _ctx.laneTarget || undefined,
          location: "bottom end"
        }, {
          activator: _withCtx(({ props }) => [
            _createVNode(_component_ontos_header_action, _mergeProps(props, {
              icon: "mdi-plus",
              color: "primary",
              label: _ctx.$tt('relationship-add'),
              onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.lane = null; _ctx.laneTarget = null})
            }), null, 16, ["label"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_list, {
              density: "compact",
              nav: ""
            }, {
              default: _withCtx(() => [
                (_ctx.offersCreate)
                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                      key: 0,
                      "prepend-icon": "mdi-plus",
                      title: _ctx.$tt('instance-create', {collection: _ctx.target.name}),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.creating = true))
                    }, null, 8, ["title"]))
                  : _createCommentVNode("", true),
                (_ctx.offersLink)
                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                      key: 1,
                      "prepend-icon": "mdi-link-variant",
                      title: _ctx.$tt('relationship-link', {collection: _ctx.target.name}),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openLinking()))
                    }, null, 8, ["title"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "target"]))
      : _createCommentVNode("", true),
    (_ctx.creating)
      ? (_openBlock(), _createBlock(_component_ontos_create_instance_dialog, {
          key: 1,
          context: {system: _ctx.ownerContext.system, idea: _ctx.target.alias},
          "initial-values": _ctx.lane ? _ctx.lane.seed : null,
          "fixed-values": _ctx.fixedValues,
          known: _ctx.createKnown,
          "full-page": false,
          onSaved: _ctx.onCreated,
          onClosed: _cache[4] || (_cache[4] = ($event: any) => (_ctx.creating = false)),
          onShowMessage: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('showMessage', $event))),
          onShowErrorMessage: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('showErrorMessage', $event)))
        }, null, 8, ["context", "initial-values", "fixed-values", "known", "onSaved"]))
      : _createCommentVNode("", true),
    (_ctx.linking)
      ? (_openBlock(), _createBlock(_component_ontos_link_existing_dialog, {
          key: 2,
          candidates: _ctx.lane ? _ctx.laneCandidates || [] : _ctx.candidates,
          loading: _ctx.lane !== null && _ctx.laneCandidates === null,
          collection: _ctx.target.pluralName,
          restriction: _ctx.lane ? _ctx.lane.values : [],
          "target-context": {system: _ctx.ownerContext.system, idea: _ctx.target.alias},
          title: _ctx.$tt('relationship-link-title', {collection: _ctx.target.pluralName}),
          subtitle: _ctx.ownerName,
          saving: _ctx.saving,
          onLink: _cache[7] || (_cache[7] = ($event: any) => (_ctx.commitLink($event))),
          onClosed: _cache[8] || (_cache[8] = ($event: any) => (_ctx.linking = false))
        }, null, 8, ["candidates", "loading", "collection", "restriction", "target-context", "title", "subtitle", "saving"]))
      : _createCommentVNode("", true)
  ], 64))
}